import styled from 'styled-components';

export const CoinsLabelWrapper = styled.span`
	font-size: 14px;
	font-weight: 400;
    font-family: ${props => props.theme.font};
    line-height: 20px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background-color: ${props => props.theme.coinsLabel.background};
	color: ${props => props.theme.coinsLabel.text};
    width: fit-content;
    border-radius: 80px;
    min-height: 24px;
`;
